import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { ExamplesPage } from '../../features/B5/examples-page';

const Search = z.object({ lang: z.enum(['he', 'en']).optional().catch(undefined) });

export const Route = createFileRoute('/_app/examples')({
  validateSearch: (s) => Search.parse(s),
  component: ExamplesRoute,
});

function ExamplesRoute() {
  const { lang } = Route.useSearch();
  return <ExamplesPage lang={lang ?? 'he'} />;
}
